export function sanitizeAccount(account) {
  const accountTitle = account.title;
  if (accountTitle === 'Other' || accountTitle === 'Unidentified' || accountTitle === undefined || accountTitle === null) {
    return `${account.firstName || ''} ${account.lastName || ''}`;
  }
  return `${accountTitle}. ${account.firstName || ''} ${account.lastName || ''}`;
}
